import { render, staticRenderFns } from "./ManageMenus.vue?vue&type=template&id=3eda2879&"
import script from "./ManageMenus.vue?vue&type=script&lang=js&"
export * from "./ManageMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports